import accountUploadDocument from '@/components/account/account-upload-document/account-upload-document.vue';
import accountSsnInfoUpload from '@/components/account/account-ssn-info-upload/account-ssn-info-upload.vue';

const documentUploadMixin = {
  data() {
    return {
      documentUploadSource: 4,
      documentUploadInfoVisible: false,
      documentUploadInfoPending: false,
      collectSsnInfo: false,
    };
  },
  components: {
    accountUploadDocument,
    accountSsnInfoUpload,
  },
  methods: {
    checkDocumentUploadFlags(data) {
      this.documentUploadInfoVisible = (data.duRequired || data.duPending);
      this.documentUploadInfoPending = data.duPending;
      this.documentUploadSource = data.duSource || this.documentUploadSource;
      this.collectSsnInfo = data.requireSSN4;
      return (data.duRequired || data.duPending);
    },
  },
};


export default documentUploadMixin;



// WEBPACK FOOTER //
// ./src/mixins/documentUpload.js